import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Observable } from 'rxjs';

import { AuthService } from './core/auth/auth.service';

@Component({
    // tslint:disable-next-line
    selector: 'body',
    template: "<router-outlet></router-outlet>",
    providers: []
})
export class AppComponent implements OnInit {

    isAuthenticated: Observable<boolean>;
    isDoneLoading: Observable<boolean>;
    canActivateProtectedRoutes: Observable<boolean>;

    constructor(private router: Router,
        private authService: AuthService) {

        this.isAuthenticated = this.authService.isAuthenticated$;
        this.isDoneLoading = this.authService.isDoneLoading$;
        this.canActivateProtectedRoutes = this.authService.canActivateProtectedRoutes$;
    }



    ngOnInit() {
        this.authService.runInitialLoginSequence();
        this.router.events.subscribe((evt) => {
            if (!(evt instanceof NavigationEnd)) {
                return;
            }
            window.scrollTo(0, 0);
        });
        let token=JSON.parse(localStorage.getItem("id_token_claims_obj"));
        sessionStorage.setItem('userID', token.name);
        ////console.log("seessionStorage- userID: ", sessionStorage.getItem('userID'))
    }
}
